export default __webpack_public_path__ + "static/media/thump.b35d44d6.png";